import dynamic from "next/dynamic";
const Layout = dynamic(() => import("../../hoc/staticLayout"), {
  loading: () => <></>,
  ssr: true,
});
const PhilosophyContent = dynamic(
  () => import("../../components/static/aboutPage/about/philosophy"),
  { loading: () => <></>, ssr: true }
);
import { withRouter } from "next/router";
import { getPhilosophyPageData } from "../../api/about";

function Philosophy(props) {
  const meta = {
    title: "About Bayan | Bayan's philosophy | Bayan",
    description:
      "Bayan is the premier islamic graduate education institution in North America. About Bayan contains executive master's program, cultivating leaders of today & Bayan's philosophy. Partner schools of Bayan are also mentioned in this page.",
    route: "about/philosophy",
  };
  return (
    <>
      <Layout theme={props.theme} meta={meta}>
        <PhilosophyContent
          router={props.router}
          philosophy={props?.philosophyPageData}
        />
      </Layout>
    </>
  );
}
export async function getServerSideProps(ctx) {
  const philosophyPageData = await getPhilosophyPageData();
  // console.log(philosophyPageData);
  return { props: { philosophyPageData: philosophyPageData?.[0] ?? null } };
}

export default withRouter(Philosophy);
